<template>
  <div class="sign-in">
    <h1>登录</h1>
    <h2>SIGN IN</h2>
    <div class="qr-corner" @click="goScan">
      <img src="../../assets/qr-corner.png" alt>
    </div>
    <div class="sign-in-form form-wrap">
      <div class="input-wrap">
        <label>手机号</label>
        <input type="text" v-model="PhoneNumber" v-focus="true">
      </div>
      <div class="input-wrap">
        <label>密码</label>
        <input type="password" v-model="PassWord">
      </div>
      <p class="tip pwd-tip" @click="findPwd">忘记密码</p>
      <button class="login-btn" @click="signIn">登录</button>
      <p class="tip">
        <span>还没有账号？去</span>
        <a class="sign-link" @click="signUp">注册</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'signIn',
  data() {
    return {
      PhoneNumber: '',
      PassWord: '',
      loading: false
    }
  },
  methods: {
    signIn() {
      let { PhoneNumber, PassWord } = this
      this.loading = true
      this.$store
        .dispatch('LoginByPhone', { PhoneNumber, PassWord })
        .then(() => {
          this.loading = false
          this.$router.push({ path: '/' })
        })
        .catch(() => {
          this.loading = false
        })
    },
    signUp() {
      this.$router.push({ path: '/login/sign-up' })
    },
    goScan() {
      this.$router.push({ path: '/login/qr-sign-in' })
    },
    findPwd() {
      this.$router.push({ path: '/login/find-pwd' })
    }
  }
}
</script>
<style lang="less" scoped>
.sign-in {
  h2 {
    margin-bottom: 70px;
  }
}
</style>
